<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Purchased: His Perfect Wife</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="aboutAuthorPage" id="abo"><h2 class="aboutAuthorHead"><span class="bold"><span>All about the author…<br/>
<em class="italic"><span>Helen Bianchin</span></em></span></span></h2><p class="aboutAuthorText"><span><span class="bold"><span>HELEN BIANCHIN</span></span> grew up in New Zealand, an only child possessed by a vivid imagination and a love for reading. After four years of legal-secretarial work, Helen embarked on a working holiday in Australia, where she met her Italian-born husband, a tobacco share farmer in far north Queensland. His command of English was pitiful, and her command of Italian was nil. Fun? Oh yes! So too was being flung into cooking for workers immediately after marriage, stringing tobacco and living in primitive conditions.</span></p><p class="aboutAuthorText"><span>It was a few years later that Helen, her husband and their daughter returned to New Zealand, settled in Auckland and added two sons to their family. Encouraged by friends to recount anecdotes of her years as a tobacco share farmer’s wife living in an Italian community, Helen began setting words on paper, and her first novel was published in 1975.</span></p><p class="aboutAuthorText"><span>Creating interesting characters and telling their stories remains as passionate a challenge for Helen as it did in the beginning of her writing career.</span></p><p class="aboutAuthorText"><span>Spending time with family, reading and watching movies are high on Helen’s list of pleasures. An animal lover, Helen says her Maltese terrier and two Birman cats regard her study as theirs as much as it is hers.</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// purchasedhisperfectwife_abo.vue?bbc3fc86